<template>
    <div style="height:292px;background-color: #000000;">
      <div style="height:212px;display: flex;">
        <div style="width: 70%;">
          <div style="width: 100px;margin-left: 120px;padding-top: 40px;">
            <img :src="logoBottom" style="width:100px;"/>
          </div>
        </div>
        <div style="width: 30%;display: flex;">
          <div style="width: 120px;padding-top: 40px;">
            <img :src="logoDownload" style="width:120px;"/>
            <div style="margin-top: 4px;
            height: 24px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #B9B3AF;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            text-transform: none;">乐活元APP</div>
          </div>
          <div style="width: 120px;margin-left: 32px;padding-top: 40px;">
            <img :src="logoWx" style="width:120px;"/>
            <div style="margin-top: 4px;
            height: 24px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #B9B3AF;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            text-transform: none;">乐活元公众号</div>
          </div>
        </div>
      </div>
      <div style="border: 1px solid #B9B3AF;opacity: 0.6;">
      </div>
      <div  style="height:80px;display: flex;align-items: center;justify-content: center;">
        <img :src="gawbPic" style="width:15px;"/> &nbsp;&nbsp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502019740" title="公安网备" style='color:white'>沪公网安备31011502019740号</a>&nbsp;&nbsp; Copyright &copy; 2023  版权所有   &nbsp;&nbsp; <a href="http://beian.miit.gov.cn/" title="ICP备案" style='color:white'>沪ICP备2023012114号</a>
      </div>
    </div>

</template>
<script>

export default {
    data() {
        return {
            picData: [
                require('../../assets/images/weixin.png')
            ],
            gawbPic: require("../../assets/images/gawb.png"),
            logoBottom: require("../../assets/website/logo-bottom.png"),
            logoDownload: require("../../assets/website/lohas-download.png"),
            logoWx: require("../../assets/website/lohas-wx.jpg"),
        }
    }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/footerBar/footerBar.vue